module.exports = __webpack_public_path__ + "media/images/icons/icons_small/45_coctail-228be6872c4e466b7a4d3218b22ff951.png";